import React from 'react';
// import PropTypes from 'prop-types';
import { ResponsiveLine } from '@nivo/line';
import moment from 'moment';
import numeral from 'numeral';

import './Charts.css';

export const TimeLine = ({
  data,
  color,
  id,
  loading,
  dateFilter,
  startDate
}) => {
  if (loading) {
    return (
      <div className="tvt-time-chart__loading-state-wrapper">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1120"
          height="334"
          viewBox="0 0 1120 334"
        >
          <defs>
            <linearGradient id="dh9frx00na" x1="0%" x2="100%" y1="50%" y2="50%">
              <stop offset="0%" stopColor="#EEEEEE" />
              <stop offset="33%" stopColor="#EEEEEE" />
              <stop offset="50%" stopColor="#f5f5f5" />
              <stop offset="67%" stopColor="#EEEEEE" />
              <stop offset="100%" stopColor="#EEEEEE" />
              <animateTransform
                attributeName="gradientTransform"
                type="translate"
                from="-1 0"
                to="1 0"
                begin="0s"
                dur="1.5s"
                repeatCount="indefinite"
              />
            </linearGradient>
          </defs>
          <path
            fill="url(#dh9frx00na)"
            fillRule="evenodd"
            d="M108 324v10H58v-10h50zm333 0v10h-50v-10h50zm-111 0v10h-50v-10h50zm-111 0v10h-50v-10h50zm333 0v10h-50v-10h50zm111 0v10h-50v-10h50zm111 0v10h-50v-10h50zm111 0v10h-50v-10h50zm111 0v10h-50v-10h50zm111 0v10h-50v-10h50zM40 302v10H0v-10h40zM1120 0v308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001h-36V308h-1v-.001H85.436l-.011.044-.154-.044H84V308h-1v-.001L57 308h-1V0h1064zM157 256.999h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 0h-36v50h36v-50zm37 .001l-36-.001v50h36V257zm-1036-.001L57 257v50l24.724-.001-.149-.042L83 301.902v-44.903zm37 0H99.811l-14.093 50H120v-50zm-24.343 0H84v41.355l11.657-41.355zM40 251v10H0v-10h40zm1042-44h-33.672l-1.18 1.66c-.296.416-.707.675-1.147.782L1046 256h36V207zm-888 0h-36v48.999h36V207zm-84.25 0H84v48.999h11.939L109.75 207zM1119 207h-36v48.999l36 .001v-49zm-76.008 0H1009v48.999h36v-46.567c-.464-.123-.888-.412-1.17-.861l-.08-.137-.758-1.434zM1008 207h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-703 0H57v49l26-.001V207zm629 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-74 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm-37 0h-36v48.999h36V207zm518 0h-36v48.999h36V207zm-592 0h-36v48.999h36V207zm481 0h-36v48.999h36V207zm-518 0h-6.096l-13.811 48.999H120V207zm-80-6v10H0v-10h40zm80-45H84v50h26.032l9.01-31.96.958-4.05V156zm896.049 0H1009v50h33.464l-26.415-50zm-8.049 0h-36v50h36v-50zm-37 0h-36v50h36v-50zm-37 0h-15.499l-19.718 31.56c-.199.318-.472.56-.783.72V206h36v-50zm-73 8.188V206h36v-17.502c-.31-.013-.622-.099-.907-.263l-.136-.085L861 164.188zM849.907 156H824v50h36v-42.497l-.584-.4-9.509-7.103zM823 156h-36v50h36v-50zm-37 0h-36v50h36v-50zm-37 0h-36v50h36v-50zm-37 0h-36v50h36v-50zm-37 0h-36v50h36v-50zm444 0h-35.797l.927.66-1.13 1.587V206h36v-50zm-481 0h-36v50h36v-50zm-37 0h-36v50h36v-50zm-37 0h-36v50h36v-50zm-37 0h-36v50h36v-50zm-259 0h-36v50h36v-50zm222 0h-36v50h36v-50zm-407 0H57v50h26v-50zm260 15.82V206h36v-15.53c-.145-.026-.29-.069-.431-.129l-.143-.067L343 171.82zM313.324 156H306v50h36v-34.701l-.066-.034L313.324 156zM305 156h-36v50h36v-50zm148 0h-36v50h36v-50zm-37 0h-18.17l-16.691 33.394c-.244.489-.66.833-1.139.997V206h36v-50zm-222 0h-36v50h36v-50zm-37 0h-29.578l-4.51 19.043-1.912 6.782V206h36v-50zm74 0h-36v50h36v-50zm-111 29.373L114.186 206H120v-20.627zm962-25.72L1049.039 206H1082v-46.347zm-2.311-3.653H1046v47.368L1079.689 156zM1045 156h-24.427L1045 202.237V156zm-666 0h-36v11.3l.8.426 34.669 18.06.531-1.065V156zm518 0h-36v3.295l.743.555 34.753 23.821.504-.809V156zm-503.643 0H380v26.72L393.357 156zm520.427 0H898v25.261L913.784 156zM342 156h-20.18L342 166.766V156zm-218.686 0H121v9.768l2.314-9.768zM40 150v10H0v-10h40zm820 6h-3.411l3.411 2.548V156zm-36-19.35V155h24.568L824 136.65zm-1.391-1.039l-35.592 5.855-.017.003V155h36v-19.097l-.391-.292zM786 141.656l-36 6.722V155h36v-13.344zm-73-25.177V155h36v-6.507c-.378-.03-.743-.169-1.05-.402l-.13-.108L713 116.48zM1119 106h-36v49h36v-49zm-444 0h-36v49h36v-49zm-592 0H57v49h26v-49zm505.277 0H565v49h36v-34.514c-.444-.053-.867-.255-1.193-.588l-.11-.122L588.278 106zM564 106h-36v49h36v-49zm-37 0h-36v49h36v-49zm-37 0h-36v49h36v-49zm-37 0h-30.398l-3.975 8.394-1.627 3.253V155h36v-49zm-37 0h-36v49h13.857l21.173-42.356.97-2.049V106zm-37 0h-36v49h36v-49zm-73 46.092V155h5.45l-5.45-2.908zm-37-3.579V155h36v-3.441l-.188-.1L269 148.513zm-37-2.961V155h36v-6.567l-36-2.881zM206.671 106H195v49h36v-9.546c-.484-.105-.914-.387-1.204-.793l-.088-.135L206.671 106zM194 106h-36v49h36v-49zm507.141 0H676v49h36v-39.425l-.634-.574L701.141 106zM638 106h-7.678l-28.18 14.284-.142.063V155h36v-49zm352.338 0H972v49h36v-14.237l-1.247-2.36L990.338 106zM897 106h-36v49h36v-49zm-761.844 0H121v49h2.55l11.606-49zM971 106h-21.87l-12.859 21.56-1.271 2.033V155h36v-49zm-37 0h-36v49h16.409l18.448-29.525L934 123.56V106zm-814 0H84v49h36v-49zm962 0h-36v49h34.401l.47-.66.927.66h.202v-49zm-73 36.656V155h6.521L1009 142.656zM1045 106h-36v27.989l1.306 2.577 9.738 18.434H1045v-49zm-111 25.194L919.126 155H934v-23.806zM157 106h-17.735l-11.606 49H157v-49zm185 0h-36v41.596c.062.02.122.043.182.068l.147.071L319.945 155H342v-49zm74 13.648L398.329 155H416v-35.352zM860 106h-36l.001 25.702c.058.029.116.06.171.094l.15.102L855.25 155H860v-49zm-555 0h-36v38.5l.077.007L305 147.46V106zm-37 0h-36v34.565l.612 1.023L268 144.42V106zm518 0h-36v38.307l36-6.72V106zm-37 0h-36v5.11l1.03.907L749 143.655V106zm-518 0h-19.668L231 138.893V106zm592 0h-36v31.415l35.8-5.888c.067-.011.134-.019.2-.023V106zm185 0h-13.179L1008 132.015V106zm-63.527 0H935v15.882L944.473 106zm-322.998 0H602v9.87l19.475-9.87zM601 106h-7.527l7.527 9.08V106zm111 0h-4.805l4.805 4.23V106zm-672-6v10H0v-10h40zm378.177 6H417v2.484l1.177-2.484zm256.73-23.093l-35.278 18.377-.629.318V105h36V82.989l-.093-.082zM1119 56h-36v49h36V56zm-481 0h-36v49h21.448l14.353-7.274.199-.104V56zm-518 0H84v49h36V56zm445 21.921V105h22.448L565 77.921zM550.638 56H528v49h36V76.715l-.777-.939-.077-.1-.071-.103L550.638 56zM527 56h-36v49h36V56zm-37 0h-36v49h36V56zm-48.139 0H417v49h1.65l23.211-49zM416 56h-36v49h36V56zm-37 0h-36v49h36V56zm-37 0h-36v49h36V56zm-37 0h-36v49h36V56zm-37 0h-36v49h36V56zm-73 30.481V105h11.074L195 86.481zM1082 56h-36v49h36V56zm-905.41 0H158v49h36V84.808l-.761-1.273L176.59 56zM83 56H57v49h26V56zm63.999 0H121v49h14.393l11.606-49zM1045 56h-36v49h36V56zm-73 13.802V105h17.831L972 69.802zM971 56h-36v49h10.07l24.769-41.525c.28-.469.7-.767 1.162-.898L971 56zm-37 0h-36v49h36V56zm-37 0h-36v49h36V56zm-37 0h-36v49h36V56zm-74 0h-36v49h36V56zm-37 0h-36v49h36V56zm-73 27.869V105h24.005L676 83.869zM823 56h-36v49h36V56zm-111 0h-36l.001 22.667c.138.06.27.137.393.228l.127.104L706.06 105H712V56zm259 13.332L949.726 105H971V69.332zM1008 56h-36v6.55c.501.111.965.415 1.262.906l.078.14L994.315 105H1008V56zm-851 0h-5.893l-11.605 49H157V56zm74 0h-36v22.718l1.667 2.756L210.734 105H231V56zm222 0h-6.714l-23.21 49H453V56zm148 0h-36v15.145l1.381 2.173L592.644 105H601V56zm37 46.109L632.295 105H638v-2.891zM675 56h-36v41.101l35.276-18.375c.23-.12.476-.191.725-.216L675 56zm-481 0h-12.736L194 77.064V56zm370 0h-8.623L564 69.571V56zM40 50v10H0V50h40zM749 1h-36v54h36V1zM638 1h-36v54h36V1zm-37 0h-36v54h36V1zm-73 19.372V55h22.003L528 20.372zm-1.622-2.553l-35.015 9.6-.363.107V55h36V18.798l-.622-.979zm-36.378 10l-35.265 10.348-.735 1.549V55h36V27.819zM453 1h-36v54h25.335l9.17-19.356c.22-.464.608-.824 1.083-1.008l.161-.055.251-.075V1zm-37 0h-36v54h36V1zm-37 0h-36v54h36V1zm-37 0h-36v54h36V1zm-37 0h-36v54h36V1zm-37 0h-36v54h36V1zm-37 0h-36v54h36V1zm-72.719 24.718L158 26.899V55h17.985l-17.704-29.282zM157 1h-36v54h26.235l8.281-34.96c.193-.813.798-1.325 1.484-1.486V1zm962 0h-36v54h36V1zM120 1H84v54h36V1zm666 0h-36v54h36V1zm37 0h-36v54h36V1zm37 0h-36v54h36V1zm37 0h-36v54h36V1zm37 0h-36v54h36V1zm37 0h-36v54h36V1zm37 0h-36v54h36V1zm37 0h-36v54h36V1zm37 0h-36v54h36V1zM83 1H57v54h26V1zm629 0h-36v54h36V1zm-37 0h-36v54h36V1zM157 31.121L151.344 55H157V31.121zM194 1h-36v17.569c.416.113.802.363 1.086.762l.088.134L180.659 55H194V1zm259 40.827L446.76 55H453V41.827zM564 1h-36v12.636c.34.132.642.356.87.657l.093.134L554.742 55H564V1zm-74 0h-36v33.213l36-10.562V1zm37 0h-36v22.371l35.746-9.8c.084-.023.17-.04.254-.052V1zM40 0v10H0V0h40z"
          />
        </svg>
      </div>
    );
  }
  const getInitialTickValues = () => {
    if (data.length > 1) {
      const start = data[0].x;
      const end = data[data.length - 1].x;
      const monthsApart = moment(start).diff(moment(end), 'months', true);
      if (monthsApart > 69) {
        return 'every 6 months';
      }
    }

    return 'every 3 months';
  };

  let tickValues = getInitialTickValues();
  let tickFormat = '%b %Y';

  const getDefaultDates = () => {
    if (!dateFilter) {
      return [
        { x: startDate || '2016-04-01' },
        { x: moment().format('YYYY-MM-DD') }
      ];
    }

    const dates = dateFilter.split(' to ');
    return [{ x: dates[0].split(' ')[0] }, { x: dates[1].split(' ')[0] }];
  };

  if (dateFilter) {
    const dates = dateFilter.split(' to ');
    const monthsApart = moment(dates[1]).diff(moment(dates[0]), 'months', true);
    if (monthsApart <= 1) {
      tickValues = 'every 2 days';
      tickFormat = '%b %d';
    } else if (monthsApart <= 8) {
      tickValues = 'every 1 weeks';
    }
  }

  const tooltip = ({
    point: {
      data: { x, y, yLabel, yLabelPercent, percentChange }
    }
  }) => {
    if (loading) {
      return <></>;
    }
    return (
      <div className="tvt-timeline__tooltip">
        <div className="tvt-timeline__tooltip-data">
          <div className="tvt-timeline__tooltip-data-date">
            {moment(x).format('ll')}
          </div>
          <div className="tvt-timeline__tooltip-data-label">
            {yLabel}:
            <div className="tvt-timeline__tooltip-data-followers">
              {numeral(y).format('0,0')}
            </div>
          </div>
          {yLabelPercent ? (
            <div className="tvt-timeline__tooltip-data-label">
              {yLabelPercent}:
              <div className="tvt-timeline__tooltip-data-followers">
                {numeral(percentChange).format('0.0%')}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  const finalData = data.length > 1 ? data : getDefaultDates();

  const axisLines =
    data.length > 1
      ? [
          {
            axis: 'x',
            value: finalData[0].x,
            lineStyle: { stroke: '#000000', strokeWidth: 1 }
          },
          {
            axis: 'y',
            value: 0,
            lineStyle: { stroke: '#000000', strokeWidth: 1 }
          }
        ]
      : [];

  return (
    <>
      {loading && (
        <div className="tvt-time-line-chart__loading-state-indicator">
          Fetching Data...
        </div>
      )}
      <ResponsiveLine
        data={[
          {
            id,
            color,
            data: finalData
          }
        ]}
        colors={color}
        margin={{ top: 50, right: 30, bottom: 50, left: 60 }}
        xScale={{
          type: 'time',
          format: '%Y-%m-%d',
          useUTC: false,
          precision: 'day'
        }}
        xFormat="time:%Y-%m-%d"
        yScale={{
          type: 'linear',
          stacked: false
        }}
        axisLeft={{
          format: ',',
          tickSize: 0
        }}
        axisBottom={{
          format: tickFormat,
          tickValues,
          legend: '',
          tickSize: 0,
          legendOffset: -12
        }}
        tooltip={tooltip}
        curve="linear"
        enablePoints={false}
        useMesh
        enableSlices={false}
        markers={axisLines}
        theme={{
          axis: {
            ticks: {
              text: {
                fontWeight: 400
              }
            }
          },
          grid: {
            line: {
              stroke: '#f5f5f5',
              strokeWidth: 1
            }
          }
        }}
      />
    </>
  );
};

TimeLine.propTypes = {};

TimeLine.defaultProps = {};

export default TimeLine;
